import React, {memo} from "react";
import PropTypes from "prop-types";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import Loader from "../../components/Loader";
import AddContactForm from "../Forms/AddContactForm";

const AddContact = (props) => {
  const {data, open, onCancel} = props;

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"lg"}>
      <Loader />
      <ModalHeader>{data && data.id ? "Edit Contact" : "Add Contact"}</ModalHeader>
      <ModalBody>
        <div className="pl-lg-4">
          <AddContactForm data={data} onCancel={onCancel} />
        </div>
      </ModalBody>
    </Modal>
  );
};

AddContact.propTypes = {
  data: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};
export default memo(AddContact);
